
export default function SuitableFor() {
  const suitable = [
    'カードの審査が不安、過去に嫌な思いをした方',
    'フリーランス、個人事業主で経費支払いをカード決済にしたい方',
    '借金するのが嫌いな方',
    '自分でカードの利用限度額を決めたい方',
    'キャッシングの案内をしてほしくない方',
    '使いすぎを防止したい方',
  ];

  const notSuitable = [
    '年会費無料のカードを探している方',
    'キャッシング機能が必要な方',
    '旅行保険が付帯したカードが欲しい方',
    'デポジットを準備できない方',
    '高還元率のカードを求めている方',
  ];

  return (
    <section className="py-16 bg-[#F8F9FA]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-12 text-center">
          デポジット型クレジットカードが向いている人・向いていない人
        </h2>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-xl shadow-lg p-6">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-[#E3F2FD] rounded-full">
                <i className="ri-thumb-up-line text-[#0099CC] text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-[#003366]">向いている人</h3>
            </div>
            <ul className="space-y-3">
              {suitable.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-check-line text-[#0099CC] text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="text-gray-700 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-[#FFF0E0] rounded-full">
                <i className="ri-thumb-down-line text-[#FF9900] text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-[#003366]">向いていない人</h3>
            </div>
            <ul className="space-y-3">
              {notSuitable.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-close-line text-[#FF9900] text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="text-gray-700 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
